import { motion } from "framer-motion";
import { MaskedLine } from "@/components/Reveal";

export default function PageHero({ eyebrow, title, accent, subtitle, testid = "page-hero" }) {
  return (
    <section className="hero-radial relative overflow-hidden pb-20 pt-44 sm:pb-28" data-testid={testid}>
      <div className="bg-grid absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black_20%,transparent_70%)]" />
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.7 }}
          className="mb-6 flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-blue-400"
          data-testid={`${testid}-eyebrow`}
        >
          <span className="inline-block h-1.5 w-1.5 animate-pulse-dot rounded-full bg-cyan-400" />
          {eyebrow}
        </motion.p>
        <h1 className="max-w-4xl font-display text-4xl font-bold leading-[1.08] tracking-tight text-white sm:text-5xl lg:text-6xl">
          <MaskedLine delay={0.15}>{title}</MaskedLine>
          {accent && (
            <MaskedLine delay={0.3}>
              <span className="text-accent-gradient">{accent}</span>
            </MaskedLine>
          )}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.55, duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="mt-7 max-w-2xl text-base leading-relaxed text-slate-400 sm:text-lg"
            data-testid={`${testid}-subtitle`}
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
